import { useNavigate } from "react-router-dom";
import BackButton from "../common/backButton";
import ChatHistory from "../common/chatHistory";
import Footer from "../common/footer";
import ContactForm from "../common/forms/contact";

const ScheduleConsultant = () => {
	const navigate = useNavigate();
	return (
		<section className="homemain ">
			<div className="container">
				<div className="row justify-content-center mt-5 pt-5">
					<div className="col-md-9">
						<article className=" text-center mb-md-5 mb-3 ">
							<h1 className="mb-md-3 mb-2 text-blue">
								Schedule a consultation
							</h1>
							<p className="text-secondary">
								Use the form below to send us a consultation request. We take
								all queries carefully, and we try to respond to each request
								individually. If you provide your email address, you agree that
								we may contact you to better understand the request you
								submitted.
							</p>
						</article>
						<div>
							<ContactForm type="consultancy" />
						</div>
					</div>
					<BackButton />
				</div>
			</div>
			<Footer />
			<ChatHistory
				onNavigate={(path: string) => {
					navigate(path);
				}}
			/>
		</section>
	);
};

export default ScheduleConsultant;
